import {scrollTo} from '../utils/_scrollTo';
import { handleReviewOrderValidation } from '../modules/checkout/_submitPaymentForm';

const showAvailableRewards = (form) => {
	if ($('#shippingAddressForm').is(':visible')) {
		handleReviewOrderValidation(form);
	 	const addressError = $('#shippingAddressForm').find('.has-error')
		const contactInfoError = $('#contactInfoInputWrapper').find('.has-error')
		if (addressError.length > 0 || contactInfoError.length > 0) {
			scrollTo('#shippingAddressForm');
			return false;
		}
	}

	handleReviewOrderValidation(form);
	const savedCardError = $('#qcCreditCard').find('p.txt-error:visible')
	const manualCardError = $('#creditCardForm').find('.has-error')
	const rewardsError = $('#rewards').find('#error-message-expired-card')
	const giftCardError = $('#gift-cards').find('#error-message-expired-card')

	if (savedCardError.length > 0 || rewardsError.length > 0 || giftCardError.length > 0 || (document.getElementById('savedCard') != null && document.getElementById('savedCard').checked && savedCardError.length > 0) || (document.getElementById('newCard').checked && manualCardError.length > 0)) {
		if (savedCardError.length > 0) {
			scrollTo(savedCardError.parent());
		}
		return false;
	}
	try {
		if (form.cc_brand.value !== undefined && form.cc_brand.value.includes("Dillards")) {
			$.ajax({
				url: '/webapp/wcs/stores/servlet/RASST200Promotions',
				cache: false,
				type: 'POST',
				data: $(form).serialize(),
				success: function (json) {
					var successResp = json.JSON;
					if (successResp.results.promos.length > 0){
						showPromotions(successResp);
					}else {
						Dillards.submitPaymentForm(document.orderReviewForm, 'ReviewOrder');
					}
					return false;
				},
			});
		 } else {
			Dillards.submitPaymentForm(document.orderReviewForm, 'ReviewOrder')
		 	return false;
		 }

	} catch (err) {
		console.log(err);
	}
};

const showPromotions = (successResp) => {
	try {
		var checkPreSelectedGoodCerts = [];
		if ($('input[name*=goodCert]').length !== 0) {
			$('input[name*=goodCert]').each(function () {
				if ($(this).val() !== '') {
					checkPreSelectedGoodCerts.push($(this).val());
				}
			});
		}

		if (successResp.results !== undefined && successResp.results.promos.length > 0) {
			var selectedPromos = [];
			$('input[name*=goodCert]').each(function () {
				if ($(this).val() !== '') {
					selectedPromos.push($(this).val());
				}
			});
			//Open modal and show available promotions
			$('#AvailableRewardsModal').modal('show');
			$('#AvailableRewardsModal').addClass('in');
			for (let i = 0; i < successResp.results.promos.length; i++) {
				var coupon = successResp.results.promos[i].coupon;
				if (checkPreSelectedGoodCerts?.includes(coupon) === false) {
					$('#available-rewards #available-rewards-list').append(`
                        <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" name="${coupon}" id="${coupon}">
							<label class="custom-control-label" for="${coupon}">
								${successResp.results.promos[i].promoDesc.toLocaleLowerCase()}
							</label>
						</div>`
					);
				}
			}

			$('#available-rewards').slideDown();
			//Select up to 5 promotions
			var selectedRewards = [];
			var availableRewards = $('#available-rewards #available-rewards-list input[type=checkbox]').length + checkPreSelectedGoodCerts.length;
			if (availableRewards >= 5) {
				availableRewards = 5;
			}
			//Check the goodCert hidden inputs to see if any were already manually added to the page, if so...add to modal view
			if ($('input[name*=goodCert]').length !== 0) {
				$('input[name*=goodCert]').each(function () {
					if ($(this).val() !== '') {
						selectedRewards.push($(this).val());
						var appendPreslected = $(this).val();
						$('#available-rewards #available-rewards-list').prepend(`
                        <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" name="${appendPreslected}" id="${appendPreslected}" checked="checked">
							<label class="custom-control-label" for="${appendPreslected}">
								${appendPreslected}
							</label>
						</div>
                `);
					}
				});
			}

			$('#available-rewards-count').text(`${selectedRewards.length} of ${availableRewards}`);
			$('#available-rewards #available-rewards-list input[type=checkbox]').each(function (i) {
				var $checkbox = $(this);
				$('#available-rewards-progressbar .progress-bar').css('width', (selectedRewards.length / availableRewards) * 100 + '%');
				$('#available-rewards-count').text(`${selectedRewards.length} of ${availableRewards}`);
				//Actions - On checkbox change
				$checkbox.on('change', function (e) {
					e.stopPropagation();
					var id = $checkbox[0].id;
					if ($checkbox.is(':checked')) {
						selectedRewards.push(id);
						$('input[name*=goodCert]').each(function () {
							if ($(this).val() == '') {
								$(this).val(id);
								var num = $(this).attr('name').split('goodCert');
								$('#promoAlertWrapper').prepend(`
								<div data-twist="appliedPromo-${num[1]}" id="appliedPromo${num[1]}" class="prompt alert-success alert" role="success" data-promo="${id}">
									<div class="d-flex justify-content-end d-inline-block float-right">
										<a data-novalidation="" class="removeReward success-link" data-reward="goodCert${num[1]}" href="javascript:void(0)">Remove</a>
									</div>
									<p><span class='couponCode d-block'>${id}</span>Congratulations! Your rewards will be applied at checkout.</p>
								</div>
								`);
								$('.removeReward').on('click', function () {
									var reward = $(this).data('reward');
									var index = reward.substr(reward.length - 1);
									$('input[name=' + reward + ']').val('');
									$('#appliedPromo' + index).remove();
								});
								return false;
							}
						});
					} else {
						selectedRewards = selectedRewards.filter((item) => item !== id);
						$('input[name*=goodCert]').each(function (index, item) {
							if ($(this).val() === id) {
								var num = $(this).attr('name').split('goodCert');
								$(this).val('');
								$(`appliedPromo${num}`).remove();
							}
						});
						$('div[data-promo]').each((i, item) => {
							if ($(item).data('promo') === id) {
								$(item).remove();
							}
						});
					}



					if (selectedRewards !== null) {
						if (selectedRewards.length === 5) {
							$('#available-rewards #available-rewards-list input[type=checkbox]').each(function (i) {
								if (!$(this).is(':checked')) {
									$(this).attr('disabled', true);
								}
							});
						} else {
							$('#available-rewards #available-rewards-list input[type=checkbox]').each(function (i) {
								$(this).attr('disabled', false);
							});
						}
					}
					$('#available-rewards-progressbar .progress-bar').css('width', (selectedRewards.length / availableRewards) * 100 + '%');
					$('#available-rewards-count').text(`${selectedRewards.length} of ${availableRewards}`);
				});
			});

			$('#AvailableRewardsModal').on('hide.bs.modal', function () {
				
				$('#available-rewards #available-rewards-list input[type=checkbox]').each(function (i) {
					var $checkbox = $(this);
					if ($checkbox.is(':checked')) {
						Dillards.submitPaymentForm(document.orderReviewForm, 'PromoModal');
						$('body').prepend('<div class="snackbar"><span>Updating rewards.</span></div>');
						$("#order-review-button").prop('disabled', true);
						$("#order-review-button").attr('data-loading', '');
					}
				});
				$("#order-review-button").prop("onclick", null).off("click");
				$('#order-review-button').attr("onclick", Dillards.submitPaymentForm(document.orderReviewForm, 'ReviewOrder'))
			});
		} else {
			$('#gift-cards').show();
			$('#available-rewards').hide();
		}
	} catch (err) {
		console.log(err);
	}
};

const billingAddressSameAsShipping = () => {
	if ($('#displayShippingAddress input[type="checkbox"]').length > 0) {
		if ($('#displayShippingAddress input[type="checkbox"]').is(':checked')) {
			$('#shippingAddressForm').hide();
		} else {
			$('#shippingAddressForm').show();
		}
		
		$('#displayShippingAddress input[type="checkbox"]').on('change', function (e) {
			if ($(this).is(':checked')) {
				$('#addressDisplay').show();
				$('#shippingAddressForm').hide();
				let erroredInput = document.querySelectorAll('#shippingAddressForm div.form-group.has-error');
				if (erroredInput.length > 0) {
					for (let x = 0; x < erroredInput.length; x++) {
						if (erroredInput[x].querySelector('input')) {
							erroredInput[x].querySelector('input').value = '';
						}
						erroredInput[x].classList.remove('has-error');
						erroredInput[x].lastElementChild.remove();
						erroredInput[x].lastElementChild.removeAttribute('aria-describedby');
					}
				}
			} else {
				$('#addressDisplay').hide();
				//clear if registered user is shipping to their register account address.  otherwise, it will update their shipping address
				if ($('#shippingAddressForm input[name="addressId"]').val() == $('.registeredUserId').text()) {
					$('#shippingAddressForm input[name="oldFirstName"]').val('');
					$('#shippingAddressForm input[name="oldLastName"]').val('');
					$('#shippingAddressForm input[name="oldAddress1"]').val('');
					$('#shippingAddressForm input[name="oldAddress2"]').val('');
					$('#shippingAddressForm input[name="oldCity"]').val('');
					$('#shippingAddressForm input[name="oldState"]').val('');
					$('#shippingAddressForm input[name="oldZipCode"]').val('');
					$('#shippingAddressForm input[name="editAddressId"]').val('');
					$('#shippingAddressForm input[name="addressId"]').val('');
					$('#shippingAddressForm input[name="nickName"]').val('');
					$('#shippingAddressForm input[name="firstName"]').val('');
					$('#shippingAddressForm input[name="lastName"]').val('');
					$('#shippingAddressForm input[name="notASearch"]').val('');
					$('#shippingAddressForm input[name="address2"]').val('');
					$('#shippingAddressForm input[name="city"]').val('');
					if($('#shippingAddressForm').find('option[value=""]').attr("selected") !== 'selected'){
						$('#shippingAddressForm').find('option').removeAttr('selected');
					}
					$('#shippingAddressForm').find('option[value=""]').attr("selected", "selected");
					$('#shippingAddressForm input[name="zipCode"]').val('');
				}
				$('#shippingAddressForm').show();
			}
		});

		$('#displayShippingAddress input[type="checkbox"]').on('keypress', function (event) {
			if (event.which === 13) {
				this.checked = !this.checked;
				if ($(this).is(':checked')) {
					$('#addressDisplay').show();
					$('#shippingAddressForm').hide();
					let erroredInput = document.querySelectorAll('#shippingAddressForm div.form-group.has-error');
					if (erroredInput.length > 0) {
						for (let x = 0; x < erroredInput.length; x++) {
							if (erroredInput[x].querySelector('input')) {
								erroredInput[x].querySelector('input').value = '';
							}
							erroredInput[x].classList.remove('has-error');
							erroredInput[x].lastElementChild.remove();
							erroredInput[x].lastElementChild.removeAttribute('aria-describedby');
						}
					}
				} else {
					$('#addressDisplay').hide();
					//clear if registered user is shipping to their register account address.  otherwise, it will update their shipping address
					if ($('#shippingAddressForm input[name="addressId"]').val() == $('.registeredUserId').text()) {
						$('#shippingAddressForm input[name="oldFirstName"]').val('');
						$('#shippingAddressForm input[name="oldLastName"]').val('');
						$('#shippingAddressForm input[name="oldAddress1"]').val('');
						$('#shippingAddressForm input[name="oldAddress2"]').val('');
						$('#shippingAddressForm input[name="oldCity"]').val('');
						$('#shippingAddressForm input[name="oldState"]').val('');
						$('#shippingAddressForm input[name="oldZipCode"]').val('');
						$('#shippingAddressForm input[name="editAddressId"]').val('');
						$('#shippingAddressForm input[name="addressId"]').val('');
						$('#shippingAddressForm input[name="nickName"]').val('');
						$('#shippingAddressForm input[name="firstName"]').val('');
						$('#shippingAddressForm input[name="lastName"]').val('');
						$('#shippingAddressForm input[name="notASearch"]').val('');
						$('#shippingAddressForm input[name="address2"]').val('');
						$('#shippingAddressForm input[name="city"]').val('');
						if($('#shippingAddressForm').find('option[value=""]').attr("selected") !== 'selected'){
							$('#shippingAddressForm').find('option').removeAttr('selected');
						}
						$('#shippingAddressForm').find('option[value=""]').attr("selected", "selected");
						$('#shippingAddressForm input[name="zipCode"]').val('');
					}
					$('#shippingAddressForm').show();
				}
			}
		});
	} else {
		$('#shippingAddressForm').show();
	}
};

const hideShowDillardsCards = () => {
	if ($('#paymentWrapper .paypal-group #paypalRadio').length > 0) {
		if ($('#paymentWrapper .paypal-group #paypalRadio').is(':checked')) {
			$('#earn-rewards').hide();
		}
		$('#paymentWrapper input[type="radio"]').on('change', function (e) {
			if ($('.paypal-group #paypalRadio').is(':checked')) {
				$('#earn-rewards').hide();
			} else {
				$('#earn-rewards').show();
			}
		});
	}

};


const handleAfterpay = () => {
	$('.removeReward').on('click', function () {
		if ($('[id^=appliedPromo]').length == 0) {
			$('.after-pay-wrapper').show();
		}
	});

	if ($('#paymentError').length > 0) {
		scrollTo('#paymentError');
	}
};


export {
	showAvailableRewards,
	billingAddressSameAsShipping,
	hideShowDillardsCards,
	handleAfterpay
};